import { jsx as e } from "react/jsx-runtime";
import { styled as t } from "@mui/joy";
import { Popper as o } from "@mui/material";
const r = t(o)({ zIndex: 1e3 }), i = ({ children: t2, isOpen: o2, buttonRef: i2, width: n }) => {
  var _a;
  return e(r, { open: o2, anchorEl: i2.current, disablePortal: true, placement: n ? "bottom-end" : void 0, modifiers: [{ name: "offset", options: { offset: [0, 4] } }], sx: { width: n || ((_a = i2.current) == null ? void 0 : _a.offsetWidth), backgroundColor: (e2) => e2.palette.isDarkMode ? e2.palette.neutral[150] : e2.palette.common.white, borderRadius: (e2) => e2.spacing(1), border: (e2) => `1px solid ${e2.palette.neutral[300]}` }, children: t2 });
};
export {
  i as PopupContainer
};
//# sourceMappingURL=PopupContainer.js.map
